import { render } from "./CompanyDetailsHeader.vue?vue&type=template&id=11a195b0"
import script from "./CompanyDetailsHeader.vue?vue&type=script&lang=js"
export * from "./CompanyDetailsHeader.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__